import client from '../utils/fetch-client';

const path = '/v2/messages';

export default {
	createMessage(config = {}) {
		return client.post(`${path}`, config);
	},
};
